import React, { useState, useEffect, useMemo, useRef } from "react";
import axios from "axios";
import axiosInstance from "../../../services/AxiosInstance";
import moment from "moment";
import "./notification.css";
import { getActiveSubscriptions, clearSubscriptionCache } from "../../../utils/subscriptionCache";

import { Link, useNavigate, useLocation } from "react-router-dom";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";

import { Dropdown } from "react-bootstrap";
import {
  shouldShowNotifications,
  getNotificationTableName,
  filterNotificationsForModule,
  filterNotificationsByMaxAge,
  notifyNotificationsUpdated,
  NOTIFICATIONS_UPDATED_EVENT,
} from './notificationScope';
import {
  getNotificationMessage,
  getNotificationTargetPath,
} from '../../../utils/notificationMessages';
import {
  isDashboardPath,
  isSettingsShellPath,
  getModuleDisplayName,
  getSettingsEntryPath,
  getActiveModule,
} from './moduleNav';
import { getHeaderSearchContext } from '../../../utils/headerSearchConfig';
import { getUniversalAddAction } from '../../../utils/universalAddConfig';
import {
  getCredentialVaultNavAddState,
  subscribeCredentialVaultNavAddState,
  canShowCredentialVaultNavAdd,
} from '../../../utils/credentialVaultNavAddBridge';
import { searchAcrossModules } from '../../../services/globalSearchService';
import { useSidebar } from './SidebarContext';
import ModuleLauncher from './ModuleLauncher';
import logIcon from '../../../images/logo no bg-01.png';
import flowdoWordmark from '../../../images/flowdo-wordmark.png';
import { getPageLabelFromPath } from '../../../utils/pageTitles';

import "./headerstyle.css";
import "./navHeader.css";

const AppsGridIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect x="1" y="1" width="4.5" height="4.5" rx="1" fill="currentColor" />
    <rect x="6.75" y="1" width="4.5" height="4.5" rx="1" fill="currentColor" />
    <rect x="12.5" y="1" width="4.5" height="4.5" rx="1" fill="currentColor" />
    <rect x="1" y="6.75" width="4.5" height="4.5" rx="1" fill="currentColor" />
    <rect x="6.75" y="6.75" width="4.5" height="4.5" rx="1" fill="currentColor" />
    <rect x="12.5" y="6.75" width="4.5" height="4.5" rx="1" fill="currentColor" />
    <rect x="1" y="12.5" width="4.5" height="4.5" rx="1" fill="currentColor" />
    <rect x="6.75" y="12.5" width="4.5" height="4.5" rx="1" fill="currentColor" />
    <rect x="12.5" y="12.5" width="4.5" height="4.5" rx="1" fill="currentColor" />
  </svg>
);

const notificationTypeMap = {
  10: "assignee",
  20: "tag",
  30: "observer",
  40: "participant",
  50: "status",
  60: "new_comment",
  70: "comment_reply",
  80: "mention",
  90: "start_date_reminder",
  100: "inactive_task",
  110: "forum_comment",
  111: "forum_reply",
  112: "forum_mention",
  120: "project_member",
  121: "project_moderator",
};
const headerNameDictionary = {
  edittask: "Edit Task",
  addtask: "Add Task",
  projectlist: "Project List",
  editproject: "Edit Project",
  projectdetails: "Project Details",
  addproject: "Add Project",
  tasklist: "Task Dashboard",
  taskboard: "Task Board",
  performance: "Performance Report",
  performancedetails: "Performance Details",
  taskdetails: "Task Details",
  userlist: "User List",
  adduser: "Add User",
  edituser: "Edit User",
  branchList: "Branch List",
  departmentList: "Department List",
  editBranch: "Edit Branch",
  editbranch: "Edit Branch",
  addBranch: "Add Branch",
  addbranch: "Add Branch",
  addDepartment: "Add Department",
  adddepartment: "Add Department",
  editDepartment: "Edit Department",
  editdepartment: "Edit Department",
  modules: "Modules",
  subscription: "Subscription",
  usersubscription: "Manage Your Subscription",
  renew: "Subscription Renewal",
  subscriptionfeaturerequired: "Feature not available",
  dashboard: "Dashboard",
  dashboarddark: "Dashboard Dark",
  projectdashboard: "Project Dashboard",
  draggable: "Draggable",
  messages: "Messages",
  projectdetails: "Project Details",
  latestactivity: "Latest Activity",
  clients: "Clients",
  task: "Task",
  horizontalsidebar: "Horizontal Sidebar",
  navheader: "Nav Header",
  dashboardheader: "Dashboard Header",
  primarysidebar: "Primary Sidebar",
  darksidebar: "Dark Sidebar",
  minisidebar: "Mini Sidebar",
  appprofile: "App Profile",
  emailcompose: "Compose Email",
  emailinbox: "Inbox",
  emailread: "Read Email",
  appcalender: "Calendar",
  postdetails: "Post Details",
  ecomproductgrid: "Product Grid",
  ecomproductlist: "Product List",
  ecomproductdetail: "Product Detail",
  ecomproductorder: "Product Order",
  ecomcheckout: "Checkout",
  ecominvoice: "Invoice",
  ecomcustomers: "Customers",
  chartsparkline: "Sparkline Chart",
  chartchartjs: "Chart.js",
  chartapexchart: "Apex Chart",
  chartrechart: "Rechart",
  uialert: "Alert",
  uibadge: "Badge",
  uibutton: "Button",
  uimodal: "Modal",
  uibuttongroup: "Button Group",
  uiaccordion: "Accordion",
  uilistgroup: "List Group",
  uicard: "Card",
  uicarousel: "Carousel",
  uidropdown: "Dropdown",
  uipopover: "Popover",
  uiprogressbar: "Progress Bar",
  uitab: "Tab",
  uipagination: "Pagination",
  uitypography: "Typography",
  uigrid: "Grid",
  ucselect2: "Select2",
  ucnouislider: "Noui Slider",
  ucsweetalert: "SweetAlert",
  uctoastr: "Toastr",
  mapjqvmap: "JQV Map",
  uclightgallery: "Light Gallery",
  editSubDepartment: "Edit Sub Department",
  addsubdepartment: "Add Sub Department",
  documents: "Documents",
  staff: "Staff",
  vehicle: "Vehicle",
  staffdetails: "Staff Details",
  vehicledetails: "Vehicle Details",
  vaultsettings: "Credentials Vault",
  credentialvaultsection: "Credentials Vault",
  credentialvaultlist: "Corporate credentials",
  personalvaultlist: "Personal credentials",
  credentialdetail: "Credential Details",
  forumlist: "Discussion Forum",
  forumdashboard: "Forum Dashboard",
  notifications: "Notifications",
  forumdetail: "Discussion Details",
  forumedit: "Edit Discussion",
  forumcreate: "Create Discussion",
  workregisterlist: "Work Register",
  workregisterteam: "Team Work Register",
  credits: "Credit wallet",
  creditspurchases: "Purchase history",
  creditspurchasedetail: "Credit details",
  creditscheckout: "Credit checkout",
};

const Header = ({ }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const showNotificationUi = shouldShowNotifications(location.pathname);
  const notificationTableName = getNotificationTableName(location.pathname);
  const { isOpen, toggleSidebar } = useSidebar();
  const [headerSearch, setHeaderSearch] = useState('');
  const [moduleLauncherOpen, setModuleLauncherOpen] = useState(false);
  const [globalResults, setGlobalResults] = useState([]);
  const [globalSearchLoading, setGlobalSearchLoading] = useState(false);
  const [globalSearchOpen, setGlobalSearchOpen] = useState(false);
  const [mobilePanel, setMobilePanel] = useState(null);
  const searchWrapRef = useRef(null);
  const searchInputRef = useRef(null);
  const skipModuleSearchSyncRef = useRef(false);
  const onDashboard = isDashboardPath(location.pathname);
  const moduleLabel = getModuleDisplayName(location.pathname, location.search, location.state);
  const activeModule = getActiveModule(location.pathname, location.search, location.state);
  const settingsPath = getSettingsEntryPath();
  const onSettings = isSettingsShellPath(location.pathname);
  const searchContext = useMemo(
    () => getHeaderSearchContext(location.pathname),
    [location.pathname]
  );
  const showHeaderSearch = !!searchContext.show;
  const [vaultNavAdd, setVaultNavAdd] = useState(() => getCredentialVaultNavAddState());
  useEffect(() => subscribeCredentialVaultNavAddState(setVaultNavAdd), []);

  const universalAdd = useMemo(() => {
    const action = getUniversalAddAction(location.pathname, location.search, location.state);
    if (!action) return null;
    const isVaultAdd =
      typeof action.to === 'string' && action.to.includes('/credential-vault/addCredential');
    if (!isVaultAdd) return action;
    if (!canShowCredentialVaultNavAdd(vaultNavAdd)) return null;
    const side =
      vaultNavAdd.side ||
      (action.to.includes('scope=personal') ? 'personal' : 'corporate');
    return {
      ...action,
      vaultSide: side,
      requiresVaultState: true,
    };
  }, [location.pathname, location.search, location.state, vaultNavAdd]);
  const searchPlaceholder = searchContext.placeholder || 'Search...';

  useEffect(() => {
    setModuleLauncherOpen(false);
    setGlobalSearchOpen(false);
    setGlobalResults([]);
    setMobilePanel(null);
  }, [location.pathname]);

  useEffect(() => {
    if (isOpen) setMobilePanel(null);
  }, [isOpen]);

  useEffect(() => {
    if (mobilePanel !== 'search') return undefined;
    const timer = window.setTimeout(() => {
      searchInputRef.current?.focus();
    }, 30);
    return () => window.clearTimeout(timer);
  }, [mobilePanel]);

  // Keep header input in sync with list-page ?search= when in module mode
  useEffect(() => {
    if (!showHeaderSearch || searchContext.mode !== 'module') {
      if (searchContext.mode === 'global') return;
      setHeaderSearch('');
      return;
    }
    const urlSearch = new URLSearchParams(location.search).get('search') || '';
    skipModuleSearchSyncRef.current = true;
    setHeaderSearch(urlSearch);
  }, [location.pathname, location.search, showHeaderSearch, searchContext.mode]);

  // Module mode: debounce writing search into the current list URL
  useEffect(() => {
    if (!showHeaderSearch || searchContext.mode !== 'module') return undefined;
    if (skipModuleSearchSyncRef.current) {
      skipModuleSearchSyncRef.current = false;
      return undefined;
    }

    const timer = window.setTimeout(() => {
      const params = new URLSearchParams(location.search);
      const current = params.get('search') || '';
      const next = headerSearch.trim();
      if (current === next) return;
      if (next) params.set('search', next);
      else params.delete('search');
      if (params.has('page')) params.set('page', '1');
      const search = params.toString();
      navigate(
        { pathname: location.pathname, search: search ? `?${search}` : '' },
        { replace: true }
      );
    }, 400);

    return () => window.clearTimeout(timer);
  }, [
    headerSearch,
    showHeaderSearch,
    searchContext.mode,
    location.pathname,
    location.search,
    navigate,
  ]);

  // Dashboard global search (debounced)
  useEffect(() => {
    if (!showHeaderSearch || searchContext.mode !== 'global') return undefined;

    const q = headerSearch.trim();
    if (q.length < 2) {
      setGlobalResults([]);
      setGlobalSearchLoading(false);
      return undefined;
    }

    let cancelled = false;
    setGlobalSearchLoading(true);
    const timer = window.setTimeout(async () => {
      try {
        const { groups } = await searchAcrossModules(q);
        if (!cancelled) {
          setGlobalResults(groups || []);
          setGlobalSearchOpen(true);
        }
      } catch (err) {
        console.error('Global search failed', err);
        if (!cancelled) setGlobalResults([]);
      } finally {
        if (!cancelled) setGlobalSearchLoading(false);
      }
    }, 350);

    return () => {
      cancelled = true;
      window.clearTimeout(timer);
    };
  }, [headerSearch, showHeaderSearch, searchContext.mode]);

  useEffect(() => {
    if (!globalSearchOpen) return undefined;
    const onPointerDown = (e) => {
      if (searchWrapRef.current && !searchWrapRef.current.contains(e.target)) {
        setGlobalSearchOpen(false);
      }
    };
    document.addEventListener('mousedown', onPointerDown);
    return () => document.removeEventListener('mousedown', onPointerDown);
  }, [globalSearchOpen]);

  const toggleMobilePanel = (panel) => {
    setMobilePanel((current) => (current === panel ? null : panel));
  };

  const handleHeaderSearchKeyDown = (e) => {
    if (e.key !== 'Enter') return;
    e.preventDefault();
    const q = headerSearch.trim();

    if (searchContext.mode === 'module') {
      const params = new URLSearchParams(location.search);
      if (q) params.set('search', q);
      else params.delete('search');
      if (params.has('page')) params.set('page', '1');
      const search = params.toString();
      navigate(
        { pathname: location.pathname, search: search ? `?${search}` : '' },
        { replace: true }
      );
      return;
    }

    if (searchContext.mode === 'global' && q.length >= 2) {
      setGlobalSearchOpen(true);
    }
  };
  var path = window.location.pathname.split("/");
  // If the previous segment is 'taskdetails', use that as the header key
  var last = path[path.length - 1];
  var prev = path[path.length - 2];
  var name = last.split("-");
  const domain = path[1];
  var filterName = name.length >= 3 ? name.filter((n, i) => i > 0) : name;
  var finalName = filterName;
  let headerTitleKey = finalName.join("").toLowerCase();
  if (last.toLowerCase() === "worksheet") {
    headerTitleKey = "worksheet";
  } else if (last.toLowerCase() === "tasklist") {
    headerTitleKey = "tasklist";
  } else if (last.toLowerCase() === "performance") {
    headerTitleKey = "performance";
  } else if (
    last.toLowerCase() === "details" &&
    prev &&
    prev.toLowerCase() === "performance"
  ) {
    headerTitleKey = "performancedetails";
  } else if (last.toLowerCase() === "subscription-feature-required") {
    headerTitleKey = "subscriptionfeaturerequired";
  }
  if (domain === "documents") {
    headerTitleKey = "documents";
  } else if (domain === "staff") {
    headerTitleKey = "staff";
  } else if (domain === "vehicle") {
    headerTitleKey = "vehicle";
  }

  if (prev && prev.toLowerCase() === "taskdetails") {
    headerTitleKey = "taskdetails";
  } else if (prev && prev.toLowerCase() === "projectdetails") {
    headerTitleKey = "projectdetails";
  } else if (prev && prev.toLowerCase() === "editbranch") {
    headerTitleKey = "editBranch";
  } else if (prev && prev.toLowerCase() === "addbranch") {
    headerTitleKey = "addBranch";
  } else if (prev && prev.toLowerCase() === "editdepartment") {
    headerTitleKey = "editDepartment";
  } else if (prev && prev.toLowerCase() === "adddepartment") {
    headerTitleKey = "addDepartment";
  } else if (prev && prev.toLowerCase() === "editsubdepartment") {
    headerTitleKey = "editSubDepartment";
  } else if (prev && prev.toLowerCase() === "addsubdepartment") {
    headerTitleKey = "addSubDepartment";
  } else if (prev && prev.toLowerCase() === "editvehicle") {
    headerTitleKey = "editVehicle";
  } else if (prev && prev.toLowerCase() === "staffdetails") {
    headerTitleKey = "staffdetails";
  } else if (prev && prev.toLowerCase() === "vehicledetails") {
    headerTitleKey = "vehicledetails";
  } else if (prev && prev.toLowerCase() === "credentialdetail") {
    headerTitleKey = "credentialvaultsection";
  } else if (last.toLowerCase() === "vaultsettings") {
    headerTitleKey = "vaultsettings";
  } else if (domain === "credential-vault" && last.toLowerCase() === "addcredential") {
    headerTitleKey = "credentialvaultsection";
  } else if (domain === "credential-vault" && prev && prev.toLowerCase() === "editcredential") {
    headerTitleKey = "credentialvaultsection";
  } else if (domain === "forum") {
    if (last.toLowerCase() === "dashboard") {
      headerTitleKey = "forumdashboard";
    } else if (last.toLowerCase() === "list") {
      headerTitleKey = "forumlist";
    } else if (last.toLowerCase() === "create") {
      headerTitleKey = "forumcreate";
    } else if (prev && prev.toLowerCase() === "detail") {
      headerTitleKey = "forumdetail";
    } else if (prev && prev.toLowerCase() === "edit") {
      headerTitleKey = "forumedit";
    }
  } else if (domain === "work-register") {
    if (last.toLowerCase() === "list") {
      headerTitleKey = "workregisterlist";
    } else if (last.toLowerCase() === "team") {
      headerTitleKey = "workregisterteam";
    }
  } else if (domain === "credits") {
    if (last.toLowerCase() === "credits") {
      headerTitleKey = "credits";
    } else if (last.toLowerCase() === "purchases") {
      headerTitleKey = "creditspurchases";
    } else if (last.toLowerCase() === "checkout") {
      headerTitleKey = "creditscheckout";
    } else if (prev && prev.toLowerCase() === "purchases") {
      headerTitleKey = "creditspurchasedetail";
    }
  }
  let user = localStorage.getItem('user');
  let userType = null;
  let isCorporateUser = false;
  if (user) {
    try {
      const parsed = JSON.parse(user);
      userType = parsed.type || parsed.role || parsed.userType || null;
      isCorporateUser = (userType || '').toLowerCase() === 'corporate';
    } catch (e) { userType = null; }
  }

  const subscribeHandler = () => {
    navigate('/subscribe')
  }

  const userPlanFeatures = async () => {
    try {
      const response = await axiosInstance.get(`/userSubscription/features`);
      if (response.data && response.data.features) {
        localStorage.setItem('userPlanFeatures', JSON.stringify(response.data.features));
      }
    } catch (error) {
      console.error('Error fetching user plan features:', error);
    }
  }

  useEffect(() => {
    userPlanFeatures();
  }, []);

  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [showNotifications, setShowNotifications] = useState(false);
  const [subscriptionsInRenewal, setSubscriptionsInRenewal] = useState([]);
  const [showRenewalDropdown, setShowRenewalDropdown] = useState(false);
  const [isTickerVisible, setIsTickerVisible] = useState(true);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [loading, setLoading] = useState(false);
  const scrollbarRef = useRef(null);
  const stateRef = useRef({ page, hasMore, loadingMore, loading });
  
  // Keep refs in sync with state
  useEffect(() => {
    stateRef.current = { page, hasMore, loadingMore, loading };
  }, [page, hasMore, loadingMore, loading]);

  const fetchUnreadCount = async () => {
    if (!shouldShowNotifications(location.pathname)) {
      setUnreadCount(0);
      return;
    }

    try {
      const user = JSON.parse(localStorage.getItem("user") || "null");
      const userId = user?.id;
      if (!userId) {
        setUnreadCount(0);
        return;
      }

      const params = new URLSearchParams({
        page: '1',
        limit: '100',
        Is_Read: 'false',
      });
      const tableName = getNotificationTableName(location.pathname);
      if (tableName) {
        params.set('TableName', tableName);
      }

      const res = await axiosInstance.get(`/notification/list/${userId}?${params.toString()}`);
      const recentUnread = filterNotificationsByMaxAge(
        filterNotificationsForModule(res.data?.notifications || [], location.pathname)
      ).filter((n) => !n.is_read);
      setUnreadCount(recentUnread.length);
    } catch (error) {
      console.error('Error fetching unread notification count:', error);
    }
  };

  const fetchNotifications = async (pageNum = 1, append = false) => {
    if (!shouldShowNotifications(location.pathname)) {
      setNotifications([]);
      setUnreadCount(0);
      setHasMore(false);
      return;
    }

    try {
      if (pageNum === 1) setLoading(true);
      else setLoadingMore(true);
      
      const user = JSON.parse(localStorage.getItem("user"));
      const userId = user?.id;

      const params = new URLSearchParams({
        page: pageNum,
        limit: 10,
      });
      const tableName = getNotificationTableName(location.pathname);
      if (tableName) {
        params.set('TableName', tableName);
      }
      
      const res = await axiosInstance.get(`/notification/list/${userId}?${params.toString()}`);
      const rawPage = res.data.notifications || [];
      const fetchedNotifications = filterNotificationsByMaxAge(
        filterNotificationsForModule(rawPage, location.pathname)
      );
      
      if (append) {
        setNotifications((prev) => [...prev, ...fetchedNotifications]);
      } else {
        setNotifications(fetchedNotifications);
      }
      
      // Stop if API page was short, or the page had items but none were recent
      // (older pages will only be older given created_at ordering after unread).
      const apiReturnedFullPage = rawPage.length === 10;
      const hadOnlyOlder = rawPage.length > 0 && fetchedNotifications.length === 0;
      setHasMore(apiReturnedFullPage && !hadOnlyOlder);
      setPage(pageNum);
    } catch (error) {
      console.error('Error fetching notifications:', error);
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  };

  const markNotificationAsRead = async (notificationId) => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const userId = user?.id;
      const wasUnread = notifications.some(
        (notif) => notif.id === notificationId && !notif.is_read
      );
      await axiosInstance.post(`/notification/read`, {
        id: notificationId,
        userid: userId,
      });
      // Always set is_read to true
      setNotifications((prev) =>
        prev.map((notif) =>
          notif.id === notificationId ? { ...notif, is_read: true } : notif
        )
      );
      if (wasUnread) {
        setUnreadCount((prev) => Math.max(0, prev - 1));
      }
      notifyNotificationsUpdated();
    } catch (error) {
      console.error('Error marking notification as read:', error);
    }
  };

  /**
   * Handle clicking on a notification:
   * - mark it as read
   * - navigate to the related task / project / forum when available
   */
  const handleNotificationClick = async (notif) => {
    if (notif?.id) {
      await markNotificationAsRead(notif.id);
    }

    setShowNotifications(false);

    const targetPath = getNotificationTargetPath(notif);
    if (targetPath) {
      navigate(targetPath);
    }
  };

  const unreadNotifications = useMemo(
    () => notifications.filter((n) => !n.is_read).slice(0, 3),
    [notifications]
  );

  useEffect(() => {
    if (!showNotificationUi) {
      setNotifications([]);
      setUnreadCount(0);
      setShowNotifications(false);
      setHasMore(false);
      return;
    }
    setIsTickerVisible(true);
    fetchNotifications(1, false);
    fetchUnreadCount();
  }, [location.pathname, showNotificationUi, notificationTableName]);

  useEffect(() => {
    if (!showNotificationUi) return undefined;
    const onUpdated = () => fetchUnreadCount();
    window.addEventListener(NOTIFICATIONS_UPDATED_EVENT, onUpdated);
    const intervalId = window.setInterval(fetchUnreadCount, 60000);
    return () => {
      window.removeEventListener(NOTIFICATIONS_UPDATED_EVENT, onUpdated);
      window.clearInterval(intervalId);
    };
  }, [showNotificationUi, notificationTableName, location.pathname]);

  const isWithinRenewalPeriod = (subscription) => {
    if (!subscription?.end_date) return false;
    const endDate = new Date(subscription.end_date);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);
    const daysUntilExpiry = Math.ceil((endDate - today) / (1000 * 60 * 60 * 24));
    const subType = (subscription.subscription_type || '').toLowerCase();
    const renewalDays = subType === 'yearly' ? 10 : 5;
    return daysUntilExpiry >= 0 && daysUntilExpiry <= renewalDays;
  };

  const isExpired = (subscription) => {
    if (!subscription?.end_date) return false;
    const endDate = new Date(subscription.end_date);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);
    return endDate < today;
  };

  const fetchRenewalSubscriptions = async () => {
    try {
      const res = await getActiveSubscriptions();
      const subs = res?.subscriptions || [];
      const inRenewal = subs.filter((s) => isWithinRenewalPeriod(s) || isExpired(s));
      setSubscriptionsInRenewal(inRenewal);
    } catch (e) {
      setSubscriptionsInRenewal([]);
    }
  };

  useEffect(() => {
    fetchRenewalSubscriptions();
  }, []);

  useEffect(() => {
    if (showRenewalDropdown) {
      fetchRenewalSubscriptions();
    }
  }, [showRenewalDropdown]);

  useEffect(() => {
    const onSubscriptionUpdate = () => {
      clearSubscriptionCache();
      fetchRenewalSubscriptions();
    };
    window.addEventListener('user-subscription-updated', onSubscriptionUpdate);
    return () => window.removeEventListener('user-subscription-updated', onSubscriptionUpdate);
  }, []);

  // Reset pagination when dropdown is opened
  useEffect(() => {
    if (showNotifications && showNotificationUi) {
      // Refresh notifications when dropdown opens
      fetchNotifications(1, false);
    }
  }, [showNotifications]);

  // Handle scroll for infinite loading
  useEffect(() => {
    if (!showNotifications || !showNotificationUi) return;

    let scrollContainer = null;
    let handleScroll = null;

    // Wait for dropdown to be rendered, then find the PerfectScrollbar container
    const timer = setTimeout(() => {
      scrollContainer = document.querySelector('.notification_dropdown .ps');
      if (!scrollContainer) return;

      handleScroll = () => {
        const scrollTop = scrollContainer.scrollTop;
        const scrollHeight = scrollContainer.scrollHeight;
        const clientHeight = scrollContainer.clientHeight;
        
        // Use refs to get latest state values
        const { hasMore: currentHasMore, loadingMore: currentLoadingMore, loading: currentLoading, page: currentPage } = stateRef.current;
        
        // Load more when scrolled near bottom (within 50px)
        const threshold = 50;
        if (
          scrollHeight - scrollTop - clientHeight < threshold &&
          currentHasMore &&
          !currentLoadingMore &&
          !currentLoading
        ) {
          fetchNotifications(currentPage + 1, true);
        }
      };

      scrollContainer.addEventListener('scroll', handleScroll, { passive: true });
    }, 100);

    return () => {
      clearTimeout(timer);
      if (scrollContainer && handleScroll) {
        scrollContainer.removeEventListener('scroll', handleScroll);
      }
    };
  }, [showNotifications]); // Only re-attach when dropdown opens/closes

  const moduleName = onDashboard ? null : (moduleLabel || null);
  const pageTitle =
    getPageLabelFromPath(location.pathname) ||
    headerNameDictionary[headerTitleKey] ||
    activeModule?.submenuTitle ||
    (onDashboard ? 'Dashboard' : moduleLabel);
  const showTicker =
    showNotificationUi && unreadNotifications.length > 0 && isTickerVisible;

  return (
    <div className={`header border-bottom header--fullwidth${showTicker ? ' header--with-ticker' : ''}`}>
      <div className="header-content">
        {showTicker && (
          <div className="notification-ticker">
            <div className="notification-ticker__label">Latest</div>
            <div className="notification-ticker__viewport">
              <div className="notification-ticker__track">
                {unreadNotifications.map((notif, idx) => (
                  <span
                    key={`unread-${idx}`}
                    className="notification-ticker__item"
                    onClick={() => handleNotificationClick(notif)}
                  >
                    <span className="notification-ticker__number">{idx + 1}.</span>
                    {getNotificationMessage(notif, { plainText: true })}
                  </span>
                ))}
                {/* Duplicate to make the loop seamless */}
                {unreadNotifications.map((notif, idx) => (
                  <span
                    key={`unread-dup-${idx}`}
                    className="notification-ticker__item"
                    onClick={() => handleNotificationClick(notif)}
                  >
                    <span className="notification-ticker__number">{idx + 1}.</span>
                    {getNotificationMessage(notif, { plainText: true })}
                  </span>
                ))}
              </div>
            </div>
            <button
              type="button"
              className="notification-ticker__close"
              onClick={() => setIsTickerVisible(false)}
              aria-label="Close latest notifications ticker"
            >
              ×
            </button>
          </div>
        )}
        <nav className="navbar navbar-expand">
          <div className="collapse navbar-collapse header-navbar-row">
            <div className="header-left-zone">
              <button
                type="button"
                className={`header-hamburger header-sidebar-toggle ${isOpen ? 'is-active' : ''}`}
                onClick={toggleSidebar}
                aria-label={isOpen ? 'Expand sidebar' : 'Collapse sidebar'}
              >
                {isOpen ? (
                  <i className="fas fa-arrow-right" aria-hidden="true" />
                ) : (
                  <>
                    <span className="line" />
                    <span className="line" />
                    <span className="line" />
                  </>
                )}
              </button>

              {/* Brand — shares the sidebar-width column with the collapse control */}
              <div className="header-brand-rail">
                <Link to="/dashboard" className="header-brand-lockup" title="flowdo">
                  <img src={logIcon} alt="" className="header-brand-icon" />
                  <span className={`header-brand-text${moduleName ? '' : ' header-brand-text--solo'}`}>
                    <img src={flowdoWordmark} alt="flowdo" className="header-brand-wordmark" />
                    {moduleName ? (
                      <span className="header-brand-module-name">{moduleName}</span>
                    ) : null}
                  </span>
                </Link>
              </div>
            </div>

            {/* Starts where the sidebar ends */}
            <div className={`header-main-strip${mobilePanel === 'search' ? ' is-search-open' : ''}${mobilePanel === 'actions' ? ' is-actions-open' : ''}`}>
              <div className="header-page-controls">
                <span className="header-page-title">{pageTitle}</span>
              </div>
              {showHeaderSearch ? (
                <div className="header-search-wrap" ref={searchWrapRef}>
                  <div className="header-search">
                    <i className="fas fa-search header-search-icon" aria-hidden="true" />
                    <input
                      ref={searchInputRef}
                      type="search"
                      className="header-search-input"
                      placeholder={searchPlaceholder}
                      value={headerSearch}
                      onChange={(e) => {
                        setHeaderSearch(e.target.value);
                        if (searchContext.mode === 'global') {
                          setGlobalSearchOpen(true);
                        }
                      }}
                      onFocus={() => {
                        if (searchContext.mode === 'global' && headerSearch.trim().length >= 2) {
                          setGlobalSearchOpen(true);
                        }
                      }}
                      onKeyDown={handleHeaderSearchKeyDown}
                      aria-label={searchPlaceholder}
                      autoComplete="off"
                    />
                    {searchContext.mode === 'global' && globalSearchOpen ? (
                      <div className="header-search-results" role="listbox" aria-label="Search results">
                        {globalSearchLoading ? (
                          <div className="header-search-results__status">Searching…</div>
                        ) : null}
                        {!globalSearchLoading && headerSearch.trim().length < 2 ? (
                          <div className="header-search-results__status">
                            Type at least 2 characters to search all modules.
                          </div>
                        ) : null}
                        {!globalSearchLoading &&
                        headerSearch.trim().length >= 2 &&
                        globalResults.length === 0 ? (
                          <div className="header-search-results__status">No matches found.</div>
                        ) : null}
                        {globalResults.map((group) => (
                          <div key={group.key} className="header-search-results__group">
                            <div className="header-search-results__group-head">
                              <span>{group.title}</span>
                              <Link
                                to={group.viewAllTo}
                                onClick={() => setGlobalSearchOpen(false)}
                              >
                                View all
                              </Link>
                            </div>
                            <ul>
                              {group.items.map((item) => (
                                <li key={`${group.key}-${item.id}`}>
                                  <Link
                                    to={item.to}
                                    onClick={() => setGlobalSearchOpen(false)}
                                  >
                                    <span className="header-search-results__title">{item.title}</span>
                                    {item.subtitle ? (
                                      <span className="header-search-results__sub">{item.subtitle}</span>
                                    ) : null}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </div>
                        ))}
                      </div>
                    ) : null}
                  </div>
                </div>
              ) : (
                <div className="header-search-wrap header-search-wrap--empty" aria-hidden="true" />
              )}
              <ul className="navbar-nav header-right">
              {universalAdd ? (
                <li className="nav-item">
                  {universalAdd.requiresVaultState ? (
                    <button
                      type="button"
                      className="nav-link header-add-link"
                      title={universalAdd.title}
                      aria-label={universalAdd.title}
                      onClick={() => {
                        navigate('/credential-vault/addCredential', {
                          state: { credentialVaultSide: universalAdd.vaultSide },
                        });
                      }}
                    >
                      <i className="fas fa-plus" aria-hidden="true" />
                    </button>
                  ) : (
                    <Link
                      to={universalAdd.to}
                      className="nav-link header-add-link"
                      title={universalAdd.title}
                      aria-label={universalAdd.title}
                    >
                      <i className="fas fa-plus" aria-hidden="true" />
                    </Link>
                  )}
                </li>
              ) : null}
              <li className="nav-item">
                <Link
                  to={settingsPath}
                  className={`nav-link header-settings-link${onSettings ? ' is-active' : ''}`}
                  title="Settings"
                  aria-label="Settings"
                >
                  <i className="fas fa-cog" aria-hidden="true" />
                </Link>
              </li>
              {isCorporateUser && subscriptionsInRenewal.length > 0 && (
                <Dropdown
                  as="li"
                  className="nav-item dropdown renewal_dropdown"
                  show={showRenewalDropdown}
                  onToggle={(isOpen) => setShowRenewalDropdown(isOpen)}
                >
                  <Dropdown.Toggle
                    className="nav-link i-false c-pointer"
                    variant=""
                    as="a"
                    data-toggle="dropdown"
                    aria-expanded="false"
                    style={{ position: 'relative' }}
                  >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                      <path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2z" fill="currentColor"/>
                    </svg>
                    <div className="renewal-icon-badge"></div>
                  </Dropdown.Toggle>
                  <Dropdown.Menu align="right" className="mt-2 dropdown-menu dropdown-menu-end" style={{ minWidth: '300px', maxWidth: '360px' }}>
                    <div style={{ padding: '16px' }}>
                      <p style={{ margin: '0 0 12px 0', fontSize: '14px', lineHeight: 1.5, color: '#374151' }}>
                        Your subscription is coming up for renewal. Please renew now to have uninterrupted usage.
                      </p>
                      <button
                        type="button"
                        className="btn btn-primary btn-sm"
                        onClick={() => {
                          setShowRenewalDropdown(false);
                          navigate(`/subscription/renew?subscriptionId=${subscriptionsInRenewal[0]?.id || ''}`);
                        }}
                        style={{ backgroundColor: '#C42126', borderColor: '#C42126' }}
                      >
                        Renew
                      </button>
                    </div>
                  </Dropdown.Menu>
                </Dropdown>
              )}
              {showNotificationUi && (
              <Dropdown
                as="li"
                className="nav-item dropdown notification_dropdown"
                show={showNotifications}
                onToggle={(isOpen) => setShowNotifications(isOpen)}
              >
                <Dropdown.Toggle
                  className="nav-link i-false c-pointer"
                  variant=""
                  as="a"
                  data-toggle="dropdown"
                  aria-expanded="false"
                  style={{ position: 'relative' }}
                >
                  <svg width="18" height="18" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M23.3333 19.8333H23.1187C23.2568 19.4597 23.3295 19.065 23.3333 18.6666V12.8333C23.3294 10.7663 22.6402 8.75902 21.3735 7.12565C20.1068 5.49228 18.3343 4.32508 16.3333 3.80679V3.49996C16.3333 2.88112 16.0875 2.28763 15.6499 1.85004C15.2123 1.41246 14.6188 1.16663 14 1.16663C13.3812 1.16663 12.7877 1.41246 12.3501 1.85004C11.9125 2.28763 11.6667 2.88112 11.6667 3.49996V3.80679C9.66574 4.32508 7.89317 5.49228 6.6265 7.12565C5.35983 8.75902 4.67058 10.7663 4.66667 12.8333V18.6666C4.67053 19.065 4.74316 19.4597 4.88133 19.8333H4.66667C4.35725 19.8333 4.0605 19.9562 3.84171 20.175C3.62292 20.3938 3.5 20.6905 3.5 21C3.5 21.3094 3.62292 21.6061 3.84171 21.8249C4.0605 22.0437 4.35725 22.1666 4.66667 22.1666H23.3333C23.6428 22.1666 23.9395 22.0437 24.1583 21.8249C24.3771 21.6061 24.5 21.3094 24.5 21C24.5 20.6905 24.3771 20.3938 24.1583 20.175C23.9395 19.9562 23.6428 19.8333 23.3333 19.8333Z" fill="currentColor" />
                    <path d="M9.98192 24.5C10.3863 25.2088 10.971 25.7981 11.6766 26.2079C12.3823 26.6178 13.1839 26.8337 13.9999 26.8337C14.816 26.8337 15.6175 26.6178 16.3232 26.2079C17.0288 25.7981 17.6135 25.2088 18.0179 24.5H9.98192Z" fill="currentColor" />
                  </svg>
                  {unreadCount > 0 && (
                    <span
                      className="notify-count-badge"
                      aria-label={`${unreadCount} unread notifications`}
                    >
                      {unreadCount > 99 ? '99+' : unreadCount}
                    </span>
                  )}
                </Dropdown.Toggle>
                <Dropdown.Menu align="right" className="mt-2 dropdown-menu dropdown-menu-end" style={{ minWidth: '300px', maxWidth: '400px' }}>
                  <PerfectScrollbar 
                    className="widget-media dlab-scroll" 
                    style={{ maxHeight: '380px' }}
                    containerRef={(ref) => { scrollbarRef.current = ref; }}
                  >
                    <ul className="timeline" style={{ margin: 0, padding: 0, listStyle: 'none' }}>
                      {loading && notifications.length === 0 ? (
                        <li className="dropdown-item" style={{ padding: '15px', textAlign: 'center', color: '#6b7280' }}>Loading notifications...</li>
                      ) : notifications.length === 0 ? (
                        <li className="dropdown-item" style={{ padding: '15px', textAlign: 'center', color: '#6b7280' }}>No notifications</li>
                      ) : (
                        notifications.map((notif, idx) => {
                          const message = getNotificationMessage(notif);
                          return (
                            <li
                              key={notif.id || idx}
                              onClick={() => handleNotificationClick(notif)}
                              className={`notification-item${notif.is_read ? ' read' : ''}`}
                              style={{ borderBottom: '1px solid #f3f4f6', cursor: 'pointer' }}
                            >
                              <div className="timeline-panel notificationlist-header marginbottom">
                                <div className="media-body">
                                  <p className="mb-1" style={{ fontSize: '14px', lineHeight: '1.4' }}>{message}</p>
                                  <small className="d-block" style={{ fontSize: '12px' }}>
                                    {notif.created_at && moment(notif.created_at).isValid()
                                      ? moment(notif.created_at).format("D MMMM YYYY")
                                      : "Date not available"}
                                  </small>
                                </div>
                              </div>
                            </li>
                          );
                        })
                      )}
                      {loadingMore && (
                        <li className="dropdown-item" style={{ padding: '15px', textAlign: 'center', color: '#6b7280' }}>
                          Loading more...
                        </li>
                      )}
                      {!hasMore && notifications.length > 0 && (
                        <li className="dropdown-item" style={{ padding: '15px', textAlign: 'center', color: '#9ca3af', fontSize: '12px' }}>
                          No more notifications
                        </li>
                      )}
                    </ul>
                  </PerfectScrollbar>
                  <div className="notification-dropdown-footer">
                    <Link
                      to="/notifications"
                      className="notification-view-all"
                      onClick={() => setShowNotifications(false)}
                    >
                      View all notifications
                    </Link>
                  </div>
                </Dropdown.Menu>
              </Dropdown>
              )}

              </ul>
              <div className="header-mobile-toggles">
                {showHeaderSearch ? (
                  <button
                    type="button"
                    className={`header-mobile-toggle${mobilePanel === 'search' ? ' is-active' : ''}`}
                    onClick={() => toggleMobilePanel('search')}
                    aria-label={mobilePanel === 'search' ? 'Close search' : 'Open search'}
                    aria-expanded={mobilePanel === 'search'}
                    title="Search"
                  >
                    <i className={`fas ${mobilePanel === 'search' ? 'fa-times' : 'fa-search'}`} aria-hidden="true" />
                  </button>
                ) : null}
                <button
                  type="button"
                  className={`header-mobile-toggle header-mobile-toggle--actions${mobilePanel === 'actions' ? ' is-active' : ''}`}
                  onClick={() => toggleMobilePanel('actions')}
                  aria-label={mobilePanel === 'actions' ? 'Hide actions' : 'Show actions'}
                  aria-expanded={mobilePanel === 'actions'}
                  title="Actions"
                >
                  <i className={`fas ${mobilePanel === 'actions' ? 'fa-times' : 'fa-ellipsis-h'}`} aria-hidden="true" />
                </button>
              </div>
              <div className="header-module-launcher-wrap">
                <button
                  type="button"
                  className={`nav-apps-grid header-module-launcher-btn${moduleLauncherOpen ? ' is-open' : ''}`}
                  title="Modules"
                  aria-label="Open modules"
                  aria-expanded={moduleLauncherOpen}
                  aria-haspopup="dialog"
                  onClick={() => setModuleLauncherOpen((open) => !open)}
                >
                  <AppsGridIcon />
                </button>
                <ModuleLauncher
                  open={moduleLauncherOpen}
                  onClose={() => setModuleLauncherOpen(false)}
                  activeModuleTitle={onSettings ? 'Settings' : activeModule?.menuTitle}
                  highlightDashboard={onDashboard}
                />
              </div>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Header;
